import { connect, MapDispatchToPropsFunction } from 'react-redux'
import { actions as apiActions } from 'api'
import App from '../App'
import * as selectors from '../../selectors'


export interface StateToProps {
  controlId: number
  scoreboardTypeId?: number
  apiPollingTimeInterval?: number
}

export interface DispatchToProps {
  getSettings: (controlId: number) => void
  getApiPollingTimeInterval: () => void
}

export const mapDispatchToProps: MapDispatchToPropsFunction<DispatchToProps, {}> = (dispatch) => ({
  getSettings: (controlId) => {
    dispatch(apiActions.getSettings(controlId))
  },
  getApiPollingTimeInterval: () => dispatch(apiActions.getApiPollingTimeInterval()),
})

export const mapStateToProps = (state: RootState): StateToProps => ({
  controlId: selectors.getControlId(state),
  scoreboardTypeId: selectors.getScoreboardTypeId(state),
  apiPollingTimeInterval: selectors.getApiPollingTimeInterval(state),
});

export const Settings = connect(mapStateToProps, mapDispatchToProps)(App);